import { createFileRoute } from '@tanstack/react-router'
import { BasesSection } from '@/features/vsl/bases/BasesSection'

export const Route = createFileRoute('/_authenticated/vsl/bases')({
  component: BasesSection,
})
